import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { BiAuthProvider } from './state/BiAuthContext'
import { BiThemeProvider } from './state/BiThemeContext'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BiThemeProvider>
      <BrowserRouter>
        <BiAuthProvider>
          <App />
        </BiAuthProvider>
      </BrowserRouter>
    </BiThemeProvider>
  </StrictMode>,
)
